import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppLoader } from '../-components/AppLoader';

function LoginLayout() {
  return <Outlet />;
}

export const Route = createFileRoute('/login')({
  validateSearch: (
    search: Record<string, unknown>
  ): { redirect?: string } =>
    typeof search.redirect === 'string'
      ? { redirect: search.redirect }
      : {},
  pendingComponent: AppLoader,
  component: LoginLayout,
});
